<template>
<div class="chapter">
<div class="inner_page">
<p class="epi">We don’t remember the dream, but the dream remembers us.</p>
<p class="right"><em>Linda Pastan</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epi.vue?75262e06